import { Card, Stack } from '@etg/wings';
import PurchasedCheckIn from '../../../containers/PurchasedCheckInGraphqlContainer';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import NotPurchasedCheckIn from './not-purchased-checkin/NotPurchasedCheckIn';

const CheckInInfo = () => {
  const { purchasedCheckInType } = useOrderDetails();
  const isCheckInPurchased = Boolean(purchasedCheckInType);

  return (
    <Stack>
      <Card>
        {isCheckInPurchased ? (
          <PurchasedCheckIn type={purchasedCheckInType} />
        ) : (
          <NotPurchasedCheckIn />
        )}
      </Card>
    </Stack>
  );
};

export default CheckInInfo;
